import countries from 'just-cldr-datasets/countries';
import states from 'just-cldr-datasets/states';
export { default as countries } from 'just-cldr-datasets/countries';
export { default as states } from 'just-cldr-datasets/states';

/**
 * Returns a country's name for a given country ISO code.
 * Unsupported ISO will be returned in UPPERCASE format.
 */
export function toCountryName(countryIso: string): string {
  const normalizedIso = normalize(countryIso);
  return countries[normalizedIso] || normalizedIso;
}

/**
 * Returns a state's name for a given combination of country and state ISO codes.
 * Unsupported ISO will be returned in UPPERCASE format.
 */
export function toStateName(countryIso: string, stateIso: string): string {
  const normalizedCountryIso = normalize(countryIso);
  const normalizedStateIso = normalize(stateIso);
  const countryStates = states[normalizedCountryIso];

  if (countryStates == null) return normalizedStateIso;
  return countryStates[normalizedStateIso] || normalizedStateIso;
}

/**
 * Returns a place name defined by a given country and state ISO codes.
 * Unsupported ISO will be returned in UPPERCASE format.
 */
export function toCountryStateName(countryIso: string, stateIso?: string): string {
  if (stateIso == null) return toCountryName(countryIso);
  return `${toCountryName(countryIso)} (${toStateName(countryIso, stateIso)})`;
}

function normalize(iso?: string): string {
  return iso == null ? iso : iso.toUpperCase();
}
